import React from "react";
import getClassNameFactory from "../../utilities/classNames";
import classNames from "classnames";

var Panel = function Panel(_ref) {
  var children = _ref.children,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className;
  var getClassName = getClassNameFactory(Panel.displayName);
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(getClassName(), className)
  }, children);
};

Panel.displayName = "Panel";
export default Panel;